/*
 *
 * BlockedModal
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 05-Sep-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import MerchantModal from '@nexidigital/merchantmodal'
import { configBlockedPopup } from './blockedConfig'
import Toggle from 'Hoc/ToggleComponent'
import appEnvRemap from 'Utility/appEnvRemap'
import { openUrl } from 'Utility/globalMethods'
import linksConfig from 'Utility/linksConfig'
import { Capacitor } from '@capacitor/core'
import './BlockedModal.scss'

const BlockedModal = (props) => {
  const handlePrimaryAction = () => {
    if (props.refreshLogin) {
      const loginPath = process.env.PATH_LOGIN || window.location.pathname
      window.location.href = window.location.origin + loginPath
      return
    }

    if (props.type === 'BLOCKED_MUST_UPDATE_APP') {
      if (Capacitor.getPlatform() === 'ios') {
        openUrl(linksConfig.appLinks.ios)
      } else {
        openUrl(linksConfig.appLinks.android)
      }
    } else {
      props.actions.doHidePopup()
    }

    if (props.type === 'REG_VAT_EMAIL_APPEMPTS_ERROR_MODAL') {
      window.location.replace(appEnvRemap.REDIRECT_PATH_LOGIN)
    }
    if (props.type === 'BLOCKED_MFA_MODAL') {
      window.location.replace(appEnvRemap.REDIRECT_PATH_LOGIN)
    }
    if (props.type === 'BLOCKED_OFFLINE_APP') {
      window.location.reload()
    }
  }

  const showContactInfo = () => {
    const types = [
      'BLOCKED_USER_SUSPEND',
      'REG_VAT_EMAIL_APPEMPTS_ERROR_MODAL',
      'BLOCKED_OFFLINE_APP',
      'BLOCKED_MUST_UPDATE_APP',
      'BLOCKED_SSL_INVALID_APP',
      'BLOCKED_ROOTED_APP'
    ]
    if (types.includes(props.type)) return false
    return true
  }

  return (
    <Toggle>
      <MerchantModal
        title={configBlockedPopup[props.type].title}
        description={configBlockedPopup[props.type].description}
        primaryAction={() => handlePrimaryAction()}
        primaryButtonLabel={configBlockedPopup[props.type].labelButton}
      >
        {showContactInfo() && (
          <div className='contacts'>
            <div className='contactInfo'>
              <p className='contactTitle'>{formattedMessage.contactLabel}</p>
              <p className='contactNumber'>{formattedMessage.contactNumber}</p>
            </div>
            <div className='contactHours'>
              <p>{formattedMessage.contactHoursAuto}</p>
              <p>{formattedMessage.contactHoursOperator}</p>
            </div>
          </div>
        )}
      </MerchantModal>
    </Toggle>
  )
}

BlockedModal.propTypes = {
  // Add here some propTypes
  type: PropTypes.string,
  actions: PropTypes.object.isRequired,
  refreshLogin: PropTypes.bool
}

BlockedModal.defaultProps = {
  // Add here some default propTypes values
  actions: {},
  type: 'BLOCKED_USER',
  refreshLogin: false
}

export default BlockedModal
